import { ClientProxy } from '../../../../base/proxy/clientProxy'

export interface CancelSerialCreditRequest {
  SerialNumber: string
  DealerCode: string
}

export interface CancelSerialCreditResponse {
  Success: boolean
  Message: string
  ErrorCode?: string
}

export class CancelSerialCreditApi extends ClientProxy {
  constructor(props: any = {}) {
    super({
      url: 'compay-payment/cancel-serial-credit',
      ...props,
    })
  }

  public async cancelCredit(request: CancelSerialCreditRequest): Promise<CancelSerialCreditResponse> {
    return await this.postAsync<CancelSerialCreditResponse>(request)
  }
}
